<template>
    <div class="legal-page" :style="{backgroundImage: 'url(/bbblurry-background.svg)'}">
        <SimpleHeaderComponent></SimpleHeaderComponent>
        <div class="legal-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import SimpleHeaderComponent from "@/components/general/SimpleHeaderComponent.vue";

export default {
    name: "LegalPageTemplate",
    components: {SimpleHeaderComponent}
}
</script>

<style>
.legal-page {
    background-attachment: fixed;
    background-size: 100% auto;
}

.legal-content {
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;
}

.legal-content .title {
    padding-top: 80px;
    font-size: 2em;
    text-align: left;
    padding-bottom: 10px;
    font-weight: normal;
}

.legal-content .subtitle {
    padding-top: 10px;
    font-size: 1.5em;
    text-align: left;
    padding-bottom: 10px;
    font-weight: normal;
}

.content {
    text-align: justify;
}
</style>